import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface UserState {
    agentDetails: any;
    userProfileInfo: any;
    agentCertificates: any;
    agentProfilePic: any;
    diwaliPdfView: any;
    countTotalAUM: any;
    isAgentARN?: Boolean;
    paymentUrl: string;
    calculatorLeads: any;
    orderSummaryData: any;
    isAgentNotAllowed?: false;
}
const rawState: UserState = {
    agentDetails: null,
    userProfileInfo: null,
    agentCertificates: null,
    agentProfilePic: undefined,
    diwaliPdfView: undefined,
    countTotalAUM: undefined,
    isAgentARN: false,
    paymentUrl: '',
    calculatorLeads: null,
    orderSummaryData: null,
};

const intialState = fromJS(rawState);

export default function userReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.FETCH_GET_AGENT_DETAILS_SUCCESS:
            return merge(state, fromJS({ agentDetails: action.payload.data }));
        case Actions.FETCH_GET_AGENT_CERTIFICATES_SUCCESS:
            return merge(state, fromJS({ agentCertificates: action.payload.data, isAgentARN: action.payload.data?.isARNHolder || false }));
        case Actions.FETCH_GET_USER_PROFILE_INFO_SUCCESS:
            return merge(state, fromJS({ userProfileInfo: action.payload.data }));
        case Actions.FETCH_GET_AGENT_PROFILE_PIC_SUCCESS:            
            return merge(state, fromJS({ agentProfilePic: action.payload.data }));
        case Actions.FETCH_GET_DIWALI_PDF_SUCCESS:            
            return merge(state, fromJS({ diwaliPdfView: action.payload.data }));
        case Actions.FETCH_GET_CUSTOMER_COUNT_SUCCESS:            
            return merge(state, fromJS({ countTotalAUM: action.payload.data }));
        case Actions.FETCH_GET_AGENT_VERIFICATION_SUCCESS:            
            return merge(state, fromJS({ isAgentNotAllowed: action.payload.data }));
        case Actions.FETCH_GET_CALCULATOR_LEADS_COUNT_SUCCESS:   
            return merge(state, fromJS({ calculatorLeads: action.payload.data }));
        case Actions.FETCH_GET_CUSTOMER_ORDER_DETAILS_SUCCESS:
            return merge(state, fromJS({ paymentUrl: action?.payload?.data?.paymentUrl, orderSummaryData:  action.payload?.data}));
        default:
            return state;
    }
}
